<template>
	<footer class="site-footer">
		<div class="site-footer__centraliser">
			<div class="site-footer__row">
				<div class="site-footer__container site-footer__container--centered">
					<div class="site-footer__start">
						<a href="/" class="dib">
							<img class="site-footer__logo" src="@/assets/img/logo-black-sm.png" alt="IGT logo" />
						</a>
					</div>
					<div class="site-footer__center">
						<nav class="site-footer__nav site-footer__nav--primary">
							<ul>
								<li>
									<router-link :to="{ name: 'AboutUs' }" @click.native="burgerOpen = false">
										<span>About Us</span>
									</router-link>
								</li>
								<li>
									<router-link v-if="$root.userHasPermission({
								'igt': ['AM', 'CM', 'SA'],
								'operator': ['affiliate', 'customer', 'performance'],
							})" :to="{ name: 'Games' }" @click.native="burgerOpen = false">
										<span>Games</span>
									</router-link>
									<template v-else>
										<span class="site-footer__nav-icon fonticon fonticon--lock"></span>
										<span>Games</span>
									</template>
								</li>
								<li>
									<router-link v-if="$root.userHasPermission({
								'igt': ['AM', 'CM', 'SA'],
								'operator': ['affiliate', 'customer', 'performance'],
							})" :to="{ name: 'PromotionalTools' }" @click.native="burgerOpen = false">
										<span>Engagement Platform</span>
									</router-link>
									<template v-else>
										<span class="site-footer__nav-icon fonticon fonticon--lock"></span>
										<span>Engagement Platform</span>
									</template>
								</li>
								<li>
									<router-link v-if="$root.userHasPermission({
								'igt': ['AM', 'CM', 'SA'],
								'operator': ['affiliate', 'customer', 'performance'],
							})" :to="{ name: 'AssetManager' }" @click.native="burgerOpen = false">
										<span>Assets</span>
									</router-link>
									<template v-else>
										<span class="site-footer__nav-icon fonticon fonticon--lock"></span>
										<span>Assets</span>
									</template>
								</li>
								<li>
									<router-link :to="{ name: 'Roadmap' }" @click.native="burgerOpen = false">
										<span>Roadmap</span>
									</router-link>
								</li>
								<li>
									<router-link v-if="$root.userHasPermission({
								'igt': ['AM', 'CM', 'SA'],
								'operator': ['affiliate', 'customer', 'performance'],
							})" :to="{ name: 'Documents' }" @click.native="burgerOpen = false">
										<span>Documents</span>
									</router-link>
									<template v-else>
										<span class="site-footer__nav-icon fonticon fonticon--lock"></span>
										<span>Documents</span>
									</template>
								</li>
								<li>
									<router-link :to="{ name: 'NewsArchive' }" @click.native="burgerOpen = false">
										<span>News</span>
									</router-link>
								</li>
								<li>
									<a href="/news-events/post/4187">RGS Support</a>
								</li>
							</ul>
						</nav>
					</div>
					<div class="site-footer__end">
						<div class="site-footer__social">
							<a href="https://www.linkedin.com/company/igtplaydigital/" target="_blank">
								<img src="@/assets/img/footer_linkedin.svg" alt="LinkedIn logo" />
							</a>
							<!-- TODO: Add Instagram link  -->
							<a href="https://www.instagram.com/igtplaydigital/" target="_blank">
								<img src="@/assets/img/footer_instagram.svg" alt="Instagram logo" />
							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="site-footer__row site-footer__row--grey">
				<div class="site-footer__container">
					<div class="site-footer__start">
						<a href="https://www.gamblingcommission.gov.uk/public-register/business/detail/60290" target="_blank">
							<img src="@/assets/img/logo--gambling-commission.png" alt="Gambling Commission logo" />
						</a>
					</div>
					<div class="site-footer__center">
						<div class="site-footer__legal">
							<p>International Game Technology PLC is licensed and regulated in Great Britain by the Gambling Commission under account number <a href="https://www.gamblingcommission.gov.uk/public-register/business/detail/60290" target="_blank" class="link--underlined">41794</a></p>
							<p>&copy; {{$moment().year()}} IGT. Company No 9127533</p>
						</div>
					</div>
					<div class="site-footer__end">
						<nav class="site-footer__nav site-footer__nav--secondary">
							<ul>
								<li>
									<a href="mailto:peter.nikashin@igt.com?subject=IGT Casino Lounge - Contact" class="link--underlined">Contact</a>
								</li>
								<li>
									<router-link :to="{ name: 'TermsAndConditions' }" class="link--underlined">Terms</router-link>
								</li>
								<li>
									<a href="https://www.igt.com/privacy-notice" class="link--underlined">Privacy</a>
								</li>
							</ul>
						</nav>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	name: 'SiteFooter',
	data () {
		return {
			user: this.$root.$data.user,
			region: this.$root.userSelectedRegionKey ? this.$root.userSelectedRegionKey : 'none'
		}
	},
	mounted() {
		if (this.user && this.region) {
			this.initBeamer()
		}
	},
	methods: {
		createBeamerConfig() {
			return {
				product_id: 'ofqIuzGb33063',
				selector: '#beamer-widget',
				top: -8,
				right: -12,
				bottom: null,
				left: null,
				filter: this.createBeamerFilter(),
				user_firstname: this.user.firstName,
				user_lastname: this.user.surname,
				user_email: this.user.email,
				user_id: this.user.id
			}
		},
		createBeamerFilter() {
			return `${this.region};${this.user.operator ? this.user.operator.name : 'none'}`
		},
		initBeamer() {
			window.beamer_config = this.createBeamerConfig()
			let beamerScript = document.createElement('script')
			beamerScript.setAttribute('src', 'https://app.getbeamer.com/js/beamer-embed.js')
			document.body.appendChild(beamerScript)
			console.log(`[BEAMER] Script added with filter "${window.beamer_config.filter}".`)
		},
		updateBeamer(params) {
			if (window.Beamer && typeof params === 'object') {
				Beamer.update(params)
			}
		},
		destroyBeamer() {
			if (window.Beamer) {
				Beamer.destroy()
				console.log(`[BEAMER] Instance destroyed.`)
			}
		}
	},
	watch: {
		'$root.$data.user'() {
			this.user = this.$root.$data.user
			if (this.user) {
				this.initBeamer()
			} else {
				this.destroyBeamer()
			}
		},
		'$root.userSelectedRegionKey'() {
			if (this.user) {
				this.region = this.$root.userSelectedRegionKey ? this.$root.userSelectedRegionKey : 'none'
				const newFilter = this.createBeamerFilter()
				this.updateBeamer({
					filter: newFilter
				})
				window.beamer_config.filter = newFilter
				console.log(`[BEAMER] Script updated with filter "${window.beamer_config.filter}".`)
			}
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "src/scss/toolkit";

.site-footer {
	color: #4a4a4a;
	text-align: center;

	@include media(not-phab) {
		font-size: .875rem;
	}

	&__row {
		padding: 2.5rem 2rem;

		&--grey {
			background: #eee;
		}
	}

	@include media(desk) {

		&__start,
		&__end {
			flex: 0 0 7rem;
		}

		&__center {
			flex: 1 1;
			justify-items: center;
		}
	}

	&__container {
		display: flex;
		flex-direction: column;
		margin: 0 auto;
		width: 100%;
		max-width: 84rem;

		@include media(desk) {
			flex-direction: row;
		}

		&--centered {
			align-items: center;
		}
	}

	&__logo {
		width: 7rem;
		height: auto;
	}

	&__nav {

		ul {
			list-style: none;
			padding: 0;

			li {
				margin: 0;
			}
		}

		&--primary {
			line-height: 1.5rem;
			margin-top: 2.5rem;

			li {
				padding: .625rem 0;
			}

			@include media(not-mob) {

				ul {
					display: flex;
					justify-content: center;
					flex-wrap: wrap;
				}

				li + li {
					margin-left: 2rem;
				}
			}

			@include media(desk) {
				margin-top: 0;
			}
		}

		&--secondary {

			@include media(phab) {
				margin-top: 2.625rem;
			}

			ul {
				display: flex;
				justify-content: center;

				li + li:before {
					content: "\00a0\00a0\00a0\2022\00a0\00a0\00a0"
				}
			}
		}
	}

	&__social {
		flex: 0 1 9rem;
		display: flex;
		margin-top: 2.5rem;

		@include media(not-phab) {
			justify-content: flex-end;
		}

		@include media(desk) {
			margin-top: 0;
		}

		a + a {
			margin-left: 1rem;
		}
	}

	&__legal {
		color: #9B9B9B;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-top: 2rem;

		@include media(desk) {
			margin-top: 0;
		}

		p {
			max-width: 35rem;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/SiteFooter.vue